<template>
  <div>
    <div>
      <h4>{{ $t('settings.research-creds') }}</h4>
      <div class="row fs-5 mb-4">
        <div class="col-md-3 ps-0" style="border-right: 1px solid #b7b7b7 !important;">
          <span>{{ $t('Investigator.professional-experience-years') }}</span><br />
          <span>{{ $t('num-years', { num: userResearchCreds?.professional_experience_years || 0 }) }}</span>
        </div>
        <div class="col-md-3" style="border-right: 1px solid #b7b7b7 !important;">
          <span>{{ $t('Investigator.clinical-research-experience-years') }}</span><br />
          <span>{{ $t('num-years', { num: userResearchCreds?.clinical_experience_years || 0 }) }}</span>
        </div>
        <div class="col-md-3" style="border-right: 1px solid #b7b7b7 !important;">
          <span>{{ $t('Investigator.as-a-principal-investigator') }}</span><br />
          <span>{{ $t('num-studies', { num: userResearchCreds?.num_clinical_studies_as_principal_investigator || 0 }) }}</span>
        </div>
        <div class="col-md-3">
          <span>{{ $t('Investigator.as-a-sub-investigator') }}</span><br />
          <span>{{ $t('num-studies', { num: userResearchCreds?.num_clinical_studies_as_sub_investigator || 0 }) }}</span>
        </div>
      </div>
    </div>
    <b-modal :id="'showFile' + null" v-model="showFileModal" hide-footer hide-header size="lg">
      <PDFJSViewer :fileName="encodeURIComponent(selectedFile)" :path="path" />
    </b-modal>
  </div>
</template>
<script>
import PDFJSViewer from '@/components/commons/Media/PDFJSViewer.vue';

export default {
  components: {
    PDFJSViewer,
  },
  data() {
    return {
      path: '/lib/pdfjs-2.13.216-dist/web/viewer.html', //path of the PDF.js viewer.html
      showFileModal: false,
      selectedFile: null,
    };
  },
  computed: {
    user() {
      return this.$store.getters['user'];
    },
    userResearchCreds() {
      return this.$store.getters['userResearchCreds'];
    },
  },
  created() {
    this.$store.dispatch('fetchUserResearchCreds');
  },
};
</script>